/**
 * @fileoverview PUT handler for the "/companies/:company_id/generative_ai_kill_switch" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdGenerativeAiOptOutCacheKeys } from "./constants";
import type { putCompanyGenerativeAiOptOutProps, CompanyGenerativeAiOptOutResult } from "./types";

export const putCompanyGenerativeAiOptOut = reactQueryMutationAdapter(
  companiesCompanyIdGenerativeAiOptOutCacheKeys,
  (props: putCompanyGenerativeAiOptOutProps): Promise<CompanyGenerativeAiOptOutResult> => {
    return fetch(
      `/companies/${props.company_id}/generative_ai_kill_switch`,
      "PUT",
      props,
      {},
      { propagateFetchRequestError: false }
    );
  }
);
